import { render, staticRenderFns } from "./IntegrationSettingsPage.vue?vue&type=template&id=8556f406&scoped=true&"
import script from "./IntegrationSettingsPage.vue?vue&type=script&lang=js&"
export * from "./IntegrationSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationSettingsPage.vue?vue&type=style&index=0&id=8556f406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8556f406",
  null
  
)

export default component.exports